export default __webpack_public_path__ + "static/media/subscriberportal_header.c36eb98e.svg";